import Navbar from '../../components/NavBar2/Container';
import SearchBar from '../../components/SearchBar/Container';
import BusinessCTA from '../../components/BusinessCTA/Container';
import Stats from '../../components/Stats/Container';
import Footer from '../../components/Footer/Container';
import * as S from './styles';
import { IPresenterProps } from './types';

const HomePresenter = (props: IPresenterProps) => {
    return (
        <S.PageContainer>

            <Navbar isSearchBarHidden={true} />

            <S.Background>

                <S.SearchBarContainer>
                    <S.TitleMain>
                        Reservá servicios cerca tuyo
                    </S.TitleMain>
                    <S.Subtitle>
                        Encuentra profesionales y negocios mejor valorados cerca de ti. Reservá tu próximo turno en segundos.
                    </S.Subtitle>
                    <SearchBar
                        isBtnDisabled={props.isBtnDisabled}
                        formData={props.formData}
                        onChange={props.onChange}
                        searchResults={props.searchResults}
                        searchBusinessCategories={props.searchBusinessCategories}
                        isCategoriesBoxVisible={props.isCategoriesBoxVisible}
                        toggleCategoriesBoxVisibility={props.toggleCategoriesBoxVisibility}
                        addCategory={props.addCategory}
                        selectedCategories={props.selectedCategories}
                        removeCategory={props.removeCategory}
                        isDatePickerVisible={props.isDatePickerVisible}
                        toggleDatePickerVisibility={props.toggleDatePickerVisibility}
                        selectedDate={props.selectedDate}
                        handleSelectDate={props.handleSelectDate}
                        isLocationBoxVisible={props.isLocationBoxVisible}
                        toggleLocationBoxVisibility={props.toggleLocationBoxVisibility}
                        searchLocations={props.searchLocations}
                        searchHoodResults={props.searchHoodResults}
                        selectLocation={props.selectLocation}
                    />
                    <S.StatText>
                        <span>136,900</span> citas reservadas hoy
                    </S.StatText>
                </S.SearchBarContainer>

            </S.Background>



            {/* Business CTA */}
            <BusinessCTA />

            {/* Stats */}
            <Stats />

            {/* Footer */}
            <Footer />
        </S.PageContainer>
    )
};

export default HomePresenter;
